module.exports = __webpack_public_path__ + "img/3.4b8f9ab2.png";